/* =============================================
   ROVEN — roven-main.js (Shopify theme)
   Shared JS: Nav, Accordion, Scroll FX, Gallery, Cart
   ============================================= */

(function () {
  'use strict';

  /* ── Sticky Nav ────────────────────── */
  const nav = document.getElementById('nav');
  if (nav) {
    const onScroll = () => {
      nav.classList.toggle('scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Mobile Nav Toggle ─────────────── */
  const hamburger = document.getElementById('nav-hamburger');
  const mobileMenu = document.getElementById('nav-mobile');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      const open = hamburger.classList.toggle('open');
      mobileMenu.classList.toggle('open', open);
      hamburger.setAttribute('aria-expanded', open);
    });
    mobileMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        hamburger.classList.remove('open');
        mobileMenu.classList.remove('open');
        hamburger.setAttribute('aria-expanded', false);
      });
    });
    document.addEventListener('click', (e) => {
      if (!nav.contains(e.target) && !mobileMenu.contains(e.target)) {
        hamburger.classList.remove('open');
        mobileMenu.classList.remove('open');
        hamburger.setAttribute('aria-expanded', false);
      }
    });
  }

  /* ── Scroll Fade-Up Animations ───────── */
  const fadeEls = document.querySelectorAll('.fade-up');
  if (fadeEls.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    fadeEls.forEach(el => observer.observe(el));
  } else {
    fadeEls.forEach(el => el.classList.add('visible'));
  }

  /* ── Hero BG Ken Burns ───────────── */
  const heroBg = document.querySelector('.hero__bg');
  if (heroBg) {
    setTimeout(() => heroBg.classList.add('loaded'), 100);
  }

  /* ── Accordion ────────────────── */
  document.querySelectorAll('.accordion__trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion__item');
      const isOpen = item.classList.contains('open');

      const accordion = trigger.closest('.accordion');
      if (accordion) {
        accordion.querySelectorAll('.accordion__item.open').forEach(openItem => {
          openItem.classList.remove('open');
          openItem.querySelector('.accordion__trigger').setAttribute('aria-expanded', false);
        });
      }

      if (!isOpen) {
        item.classList.add('open');
        trigger.setAttribute('aria-expanded', true);
      }
    });
  });

  /* ── Product Gallery Thumbnails ──────── */
  const thumbs = document.querySelectorAll('.gallery__thumb');
  const mainImg = document.querySelector('.gallery__main img');
  if (thumbs.length && mainImg) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const src = thumb.querySelector('img').src;
        mainImg.style.opacity = '0';
        setTimeout(() => {
          mainImg.src = src;
          mainImg.style.opacity = '1';
        }, 160);
      });
    });
  }

  /* ── Smooth inner-page scroll offset for fixed nav ── */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const target = document.querySelector(anchor.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      const offset = (nav ? nav.offsetHeight : 68) + 16;
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });

  /* ── Cart Badge (Shopify Ajax Cart API) ──── */
  function updateCartBadge(count) {
    document.querySelectorAll('.cart-badge').forEach(badge => {
      badge.textContent = count;
      badge.style.display = count > 0 ? '' : 'none';
    });
  }

  function refreshCartBadge() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => updateCartBadge(cart.item_count))
      .catch(() => {});
  }

  /* ── Product Color Selector ───────── */
  const colorSwatches = document.querySelectorAll('.color-swatch');
  const colorNameLabel = document.getElementById('selected-color-name');
  const addToCartBtn = document.getElementById('add-to-cart-btn');
  const priceEl = document.querySelector('[data-product-price]');
  const addToCartLabel = document.querySelector('[data-add-to-cart-label]');

  if (colorSwatches.length && colorNameLabel && addToCartBtn) {
    colorSwatches.forEach(swatch => {
      swatch.addEventListener('click', () => {
        colorSwatches.forEach(s => {
          s.classList.remove('active');
          s.setAttribute('aria-pressed', 'false');
          s.style.borderColor = 'transparent';
          if (s.dataset.color === 'White') {
            s.style.boxShadow = 'inset 0 0 0 1px rgba(0,0,0,0.1)';
          }
        });

        swatch.classList.add('active');
        swatch.setAttribute('aria-pressed', 'true');
        swatch.style.borderColor = 'var(--c-green)';
        if (swatch.dataset.color === 'White') {
          swatch.style.boxShadow = 'none';
        }

        const selectedColor = swatch.dataset.color;
        colorNameLabel.textContent = selectedColor;
        addToCartBtn.dataset.variantId = swatch.dataset.variantId;

        if (priceEl && swatch.dataset.price) priceEl.textContent = swatch.dataset.price;
        if (addToCartLabel && swatch.dataset.price) {
          addToCartLabel.textContent = 'Add to Cart — ' + swatch.dataset.price;
        }

        const mainGalleryImg = document.getElementById('gallery-main-img');
        if (mainGalleryImg && swatch.dataset.image) {
          mainGalleryImg.style.opacity = '0';
          setTimeout(() => {
            mainGalleryImg.src = swatch.dataset.image;
            mainGalleryImg.style.opacity = '1';
          }, 160);
        }
      });
    });
  }

  /* ── Add to Cart (Shopify Ajax API) ───── */
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', () => {
      const variantId = addToCartBtn.dataset.variantId;
      if (!variantId || addToCartBtn.disabled) return;

      const originalLabel = addToCartLabel ? addToCartLabel.textContent : addToCartBtn.textContent;
      addToCartBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(res => {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(() => {
          refreshCartBadge();
          if (addToCartLabel) addToCartLabel.textContent = 'Added to Cart ✓';
          setTimeout(() => {
            if (addToCartLabel) addToCartLabel.textContent = originalLabel;
            addToCartBtn.disabled = false;
          }, 1400);
        })
        .catch(() => {
          if (addToCartLabel) addToCartLabel.textContent = 'Something went wrong';
          setTimeout(() => {
            if (addToCartLabel) addToCartLabel.textContent = originalLabel;
            addToCartBtn.disabled = false;
          }, 1800);
        });
    });
  }

  /* ── Cart Page (Shopify Ajax API) ─────── */
  const cartItemsEl = document.getElementById('cart-items');
  if (cartItemsEl) {
    cartItemsEl.addEventListener('click', (e) => {
      const itemEl = e.target.closest('.cart-item');
      if (!itemEl) return;
      const line = parseInt(itemEl.dataset.line, 10);

      if (e.target.closest('.qty-btn')) {
        const action = e.target.closest('.qty-btn').dataset.action;
        const qtyValueEl = itemEl.querySelector('.qty-value');
        let qty = parseInt(qtyValueEl.textContent, 10);
        qty = action === 'increase' ? qty + 1 : qty - 1;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: line, quantity: qty })
        })
          .then(res => res.json())
          .then(() => window.location.reload())
          .catch(() => window.location.reload());
      } else if (e.target.closest('.cart-item__remove')) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: line, quantity: 0 })
        })
          .then(res => res.json())
          .then(() => window.location.reload())
          .catch(() => window.location.reload());
      }
    });
  }

})();
